import { trialEffective } from '@/apis/membership'
import { ref } from 'vue'
import store from '@/store'
import { getActivePriceByStation } from './useYan'

export const getNewMemberActivity = () => {
  trialEffective().then(res => {
    if (res.data.id && res.data?.membershipTrialActivityComboReqDTOS.length) {
      const trialDiscount = res.data?.membershipTrialActivityComboReqDTOS?.[0]?.trialDiscount
      // specialTrialDiscount 0:1日元活动，-2是0元活动
      const hasSpecialTrialDiscount = trialDiscount === 0 || trialDiscount === -2
      let specialPrice = null
      if (trialDiscount === 0) {
        specialPrice = getActivePriceByStation()
      } else if (trialDiscount === -2) {
        specialPrice = 0
      } else {
        specialPrice = `${String((10 - trialDiscount) * 10)}`
      }
      store.commit('status/newMemberActivity', { ...res.data, hasSpecialTrialDiscount, specialPrice })
    } else {
      store.commit('status/newMemberActivity', false)
    }
  }).catch(res => {
    store.commit('status/newMemberActivity', false)
  })
}
